import styled from "styled-components"

export const SelectInput = styled.select`
  width: 11.5vw;
  height: 4.3vh;
  background-color: #EBEBEB;
  border: 0;
  border-radius: 2vw;
  padding-left: 1vw;
  padding-right: 1vw;
  cursor: pointer;

  -webkit-appearance: none;
  appearance: none;

  :focus {
    outline: 0;
  }
`

export const SelectOption = styled.option`
  background-color: #EBEBEB;
  border: 0;
  margin-top: 0.8vh;
  padding-left: 1vw;
  padding-right: 1vw;
`